import { useLingui } from "@lingui/react";
import { observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom";

import { AppModel } from "../../app-model";
import { buildMenu } from "../menu/nav-menu";
import { getActiveSubmenu, LegacyMenuList } from "./legacy-menu-list";

/** The pre-redesign sidebar: the active section's pages as one nested list. */
export const LegacySidebar = observer(function LegacySidebar({
  app,
}: {
  app: AppModel;
}) {
  const { i18n } = useLingui();
  const pathname = useLocation().pathname;
  const sidebarMenu = getActiveSubmenu(
    buildMenu(app, pathname, i18n),
    pathname,
  );

  // Hidden on mobile — the page menu lives in the burger drawer there.
  return (
    <div className="w-60 shrink-0 border-r border-[var(--menu-sidebar-border)] bg-[var(--menu-sidebar-bg)] pt-[93px] pb-[93px] text-left text-base max-nav:hidden">
      {sidebarMenu && <LegacyMenuList items={sidebarMenu} variant="sidebar" />}
    </div>
  );
});
